const initState = {
  loading: false,
  loaded: false,
  data: []
};

export default initState;
